import { render, staticRenderFns } from "./OrdersPerTimeFrame.vue?vue&type=template&id=4516fcd1&scoped=true"
import script from "./OrdersPerTimeFrame.vue?vue&type=script&lang=js"
export * from "./OrdersPerTimeFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4516fcd1",
  null
  
)

export default component.exports